import { AfterViewInit, Component, Host, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AlarmNotificationConfigElement as AlarmConfigurationElement } from '../models/alarm-notification-config.model';
import { AlarmConfigService } from '../services/alarm-config.service';
import { MenusComponent } from '../menus/menus.component';
import { CompanyService } from '../services/company.service';
import { CompanyElement } from '../models/company.model';
import { StorageService } from '../services/storage.service';
import { DialogService } from '../services/dialog.service';

export enum AlarmConfigurationFunctionMode {
  WORKER = 'W',
  COMPANY = 'C',
}

@Component({
  selector: 'app-alarm-configuration',
  templateUrl: './alarm-configuration.component.html',
  styleUrl: './alarm-configuration.component.css'
})
export class AlarmConfigurationComponent {

  // Configuración de alarma por defecto
  public alarmConfiguration: AlarmConfigurationElement = {
    alarm_type: 1,
    retention_time: -1,
    timetable: "",
    start_time: -1,
    finish_time: -1,
    start_time2: -1,
    finish_time2: -1,
    parent_type: "",
    parent_id: -1,
  };

  weekDays = [
    { codigo: 'MON', descripcion: 'Lunes' },
    { codigo: 'TUE', descripcion: 'Martes' },
    { codigo: 'WED', descripcion: 'Miércoles' },
    { codigo: 'THU', descripcion: 'Jueves' },
    { codigo: 'FRI', descripcion: 'Viernes' },
    { codigo: 'SAT', descripcion: 'Sábado' },
    { codigo: 'SUN', descripcion: 'Domingo' }
  ];
  
  selectedWorkDays: string[] = [];
  timeFrom: string = '';
  timeTo: string = '';
  timeFrom2: string = '';
  timeTo2: string = '';
  minimumAlertTime: string = ''
  companys: CompanyElement[] = [];
  
  isDialog: boolean = false;

  constructor(
    @Optional() private dialogRef: MatDialogRef<AlarmConfigurationComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: AlarmConfigurationElement,
    private route: ActivatedRoute,
    private alarmConfigService: AlarmConfigService,
    private companyService: CompanyService,
    public storageService: StorageService,
    public dialogService: DialogService,
  ) {
    this.isDialog = !!dialogRef;

    if (this.isDialog) {
      // Caso de diálogo
      console.log("Dialogo")
        this.alarmConfiguration.parent_type = data?.parent_type;
        this.alarmConfiguration.parent_id = data?.parent_id;
        this.getAlarmConfig();
    } else {
      // Caso de app-routing
      console.log("App-routing")
      this.route.data.subscribe(params => {
        this.alarmConfiguration.parent_type = params['parent_type'];
        if(this.alarmConfiguration.parent_type == AlarmConfigurationFunctionMode.COMPANY){
          this.alarmConfiguration.parent_id = this.storageService.companyId;
          this.getAlarmConfig()
        }
      });
    }

    // Solo cargamos todas las compañias si el usuario es superadmin
    if(this.storageService.roleId == 1) {
      companyService.getAllCompanies().subscribe({
        next: (res) => {
          this.companys = res.data;
        },
        error: (error) => {
          let msg = error.error.message;
          this.msgDialog(msg, '', false, 'error')
        }
      });
    }

  }


  private getAlarmConfig() {
    if(this.alarmConfiguration.parent_id>0) {
      this.alarmConfigService.getAlarmConfig(this.alarmConfiguration.parent_type, this.alarmConfiguration.parent_id).subscribe({
        next: (res) => {
          if (res != null) {
            this.alarmConfiguration = res;
            this.timeFrom = this.alarmConfiguration.start_time?.toString().padStart(4, '0').replace(/(\d{2})(\d{2})/, '$1:$2');
            this.timeTo = this.alarmConfiguration.finish_time?.toString().padStart(4, '0').replace(/(\d{2})(\d{2})/, '$1:$2');
            this.timeFrom2 = this.alarmConfiguration.start_time2?.toString().padStart(4, '0').replace(/(\d{2})(\d{2})/, '$1:$2');
            this.timeTo2 = this.alarmConfiguration.finish_time2?.toString().padStart(4, '0').replace(/(\d{2})(\d{2})/, '$1:$2');
            this.selectedWorkDays = this.getSelectedWorkDays(this.alarmConfiguration.timetable);
          }
        },
        error: (e) => {
          console.error(e);
          let msg = e.error.message;
          this.msgDialog(msg, '', false, 'error')
        }});
      }
  }

  public onGuardarItm() {
    this.alarmConfiguration.timetable = this.convertTimetable(this.selectedWorkDays);
    this.alarmConfiguration.start_time = parseInt(this.timeFrom.replace(':', ''));
    this.alarmConfiguration.finish_time = parseInt(this.timeTo.replace(':', ''));
    this.alarmConfiguration.start_time2 = parseInt(this.timeFrom2.replace(':', ''));
    this.alarmConfiguration.finish_time2 = parseInt(this.timeTo2.replace(':', ''));
    console.log('alarmNotification', this.alarmConfiguration);

    this.alarmConfigService.insertOrUpdateAlarm(this.alarmConfiguration).subscribe({
      next: (res) => {
        this.msgDialog(
          res.message, '', true, 'success')
      },
      error: (e) => {
        console.error(e);
        let msg = e.error.message;
        this.msgDialog(msg, '', false, 'error')
      },
    });
  }

  msgDialog(msgShow:string, msg2Show:string, isOK:boolean, type:string){
    this.dialogService.confirmDialog({
      title: 'Configuración de Alarma',
      message: msgShow,
      message2: msg2Show,
      confirmText: 'OK',
      cancelText: '',
      showConfirmBox: false,
      dialogType: type,
    })
    .subscribe((yes) => {
      if (isOK && this.isDialog) {
        this.dialogRef.close(this.alarmConfiguration);
      }
    });
  }

  convertTimetable(timetable: string[]): string {
    let binaryString = '';
    for (const day of this.weekDays) {
      if (timetable.includes(day.codigo)) {
      binaryString += '1';
      } else {
      binaryString += '0';
      }
    }
    return binaryString;

  }

  getSelectedWorkDays(timetable: string): string[] {
    const selectedDays: string[] = [];
    console.log("Selected days", timetable)
    for (let i = 0; i < timetable.length; i++) {
      if (timetable[i] === '1') {
        selectedDays.push(this.weekDays[i].codigo);
      }
    }
    return selectedDays;
  }

  isTimeRangeValid(): boolean {
    if (this.timeFrom && this.timeTo && this.timeFrom2 && this.timeTo2) {
      const fromParts = this.timeFrom.split(':');
      const toParts = this.timeTo.split(':');
      const fromParts2 = this.timeFrom2.split(':');
      const toParts2 = this.timeTo2.split(':');
    
      const fromMinutes = parseInt(fromParts[0], 10) * 60 + parseInt(fromParts[1], 10);
      const toMinutes = parseInt(toParts[0], 10) * 60 + parseInt(toParts[1], 10);
      const fromMinutes2 = parseInt(fromParts2[0], 10) * 60 + parseInt(fromParts2[1], 10);
      const toMinutes2 = parseInt(toParts2[0], 10) * 60 + parseInt(toParts2[1], 10);
      let result = fromMinutes < toMinutes && fromMinutes2 < toMinutes2 && fromMinutes2 > toMinutes;
      return result;
    } else {
      return false;
    }
  }
  
  onCompanySelected(selectedcCompany: CompanyElement) {
    this.cleanData()
    console.log("Selected company", selectedcCompany.toString())
    this.alarmConfiguration.parent_id = selectedcCompany.id;
    this.alarmConfiguration.parent_type = AlarmConfigurationFunctionMode.COMPANY;
    this.getAlarmConfig();
  }

  public deleteWorkerConfig() {
    this.alarmConfigService.deleteAlarmConfig('W', this.alarmConfiguration.parent_id).subscribe({
      next: (res) => {
        this.msgDialog(
          res.message, '', true, 'success')
      },
      error: (e) => {
        console.error(e);
        let msg = e.error.message;
        this.msgDialog(msg, '', false, 'error')
      },
    });
  }

  cleanData() {
    this.alarmConfiguration = {
      alarm_type: 1,
      retention_time: -1,
      timetable: "",
      start_time: -1,
      finish_time: -1,
      start_time2: -1,
      finish_time2: -1,
      parent_type: "",
      parent_id: -1,
    };
    this.selectedWorkDays = [];
    this.timeFrom = '';
    this.timeTo = '';
    this.timeFrom2 = '';
    this.timeTo2 = '';
  }

}
